import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import FbShare, { FB_ICON_CLASS_NAME } from './FbShare';
import { playIcon } from '../../shared/styles/icons';
import { styles } from './videoItemStyles';
import { loadVideoPlayer } from '../services/VideoPlayerService';
import FsPlayer from '../components/FsPlayer';
import { media } from '../styles/constants';
import {decodeText, parseImagesTag, parseSeconds} from '../../shared/utils';
import VideoModal from '../../videoModal/components/VideoModal';

const SHOW_LOGO_SHOWN_MIN_WIDTH = 360;
const FB_SHARE_SHOWN_MIN_WIDTH = 375;
const INLINE_VIDEO_MIN_WIDTH = 261;
const LARGE_FONT_SHOWN_MIN_WIDTH = 347;

const containerSize = {
	LARGE: 560,
	MEDIUM: 360
};

class Style {
	constructor(){
		this[media.LAPTOP] = {};
		this[media.TABLET] = {};
		this[media.MOBILE] = {};
	}
}

class VideoItem extends React.Component {
	constructor(props) {
		super(props);

		this.state = {videoHover: false};

		this.loader = null;
		this.isPlaying = false;

		this.playVideo = this.playVideo.bind(this);
		this.toggleVideoHover = this.toggleVideoHover.bind(this);
		this.isShow = this.props.isShow;

		this.isModalEnabled = document.body.classList.contains('video-modal');
		this.modalCont = document.getElementById('video-player-modal');
		this.onResize = this.updateElementsVisibility.bind(this);
		this.onResize = this.updateElementsVisibility.bind(this);
	}

	toggleVideoHover(){
		this.setState({videoHover: !this.state.videoHover});
	}

	isContainerWidthOk(width) {
		if (!this.container) {
			return false;
		}

		return this.container.offsetWidth >= width;
	}

	getContainerSize(){
		if (!this.container) {
			return '';
		}

		if (this.container.offsetWidth < containerSize.MEDIUM) {
			return 'small';
		}

		if (this.container.offsetWidth < containerSize.LARGE) {
			return 'medium';
		}

		return 'large';
	}

	updateElementsVisibility() {
		return this._isMounted && this.forceUpdate();
	}

	updateMediaStyles(){
		const mediaSettings = this.props.mediaSettings;

		let item = new Style();
		let firstItem = new Style();
		let firstItemMeta = new Style();
		let itemMeta = new Style();

		Object.assign(item, mediaSettings.desktop.item);
		Object.assign(item[media.LAPTOP], mediaSettings.laptop.item);
		Object.assign(item[media.TABLET], mediaSettings.tablet.item);
		Object.assign(item[media.MOBILE], mediaSettings.mobile.item);

		if (mediaSettings.desktop.firstItem) {
			Object.assign(firstItem, mediaSettings.desktop.firstItem);

			this.addFirstItemStyles = true;
		}

		if (mediaSettings.mobile.firstItem) {
			Object.assign(firstItem[media.MOBILE], mediaSettings.mobile.firstItem);

			this.addFirstItemStyles = true;
		}

		if (mediaSettings.mobile.firstItemMeta) {
			Object.assign(firstItemMeta[media.MOBILE], mediaSettings.mobile.firstItemMeta);

			this.addFirstItemMetaStyles = true;
		}

		if (mediaSettings.mobile.itemMeta) {
			Object.assign(itemMeta[media.MOBILE], mediaSettings.mobile.itemMeta);

			this.addItemMetaStyles = true;
		}

		this.itemMediaStyles = StyleSheet.create({
			item: item,
			firstItem: firstItem,
			firstItemMeta: firstItemMeta,
			itemMeta: itemMeta
		});
	}

	componentWillMount() {
		this.updateMediaStyles();
	}

	componentDidMount() {
		this._isMounted = true;
		setTimeout(this.onResize, 0);
		this.player.setAttribute('enable-pinning', 'true');

		if (window){
			window.addEventListener("resize", this.onResize);
		}
	}

	componentWillUnmount() {
		this._isMounted = false;
		if (window){
			window.removeEventListener("resize", this.onResize);
		}
	}

	playVideo(e) {

		let isCatLink = ((target) => {

			if ( target.tagName === "IMG" ) { target = target.parentElement || target.parentNode; }
			if ( target.tagName === "A" && target.className.indexOf('categoryLogoContainer') > -1 ) {
				return true;
			}

			return false;
		})(e.target);

		if (e.target.className.indexOf(FB_ICON_CLASS_NAME) >= 0
			|| (!this.isContainerWidthOk(INLINE_VIDEO_MIN_WIDTH) && !this.isPlaying) 
			|| isCatLink || this.props.post.open_in_new_window === "1" || e.target.className.indexOf("share-btn") >= 0) {
			return;
		}

		//skip playing the video inline if scroll to home flag has been added
		let isScrollToHome = document.querySelector('.scrollToHome');
		if(isScrollToHome) return;

		e.stopPropagation();
		e.preventDefault();

        if(this.isModalEnabled){
			this.modalCont.style = 'display:block';
			//render the modal
			ReactDOM.render(<VideoModal videoConfig={this.player.getAttribute('data-player-config')} category={this.props.post.category_meta.category_name}
			title={this.props.post.title} pubDate={this.props.post.pub_date} videoUrl={this.props.post.url}/>, this.modalCont);
		} else {

			if (this.isPlaying) {
				return;
			}

			this.isPlaying = true;

			loadVideoPlayer(
				this.player,
				this.link.offsetWidth,
				this.link.offsetHeight,
				() => {
					this.link.style.display = 'none';
				}
			);
		}
	}

	getClassName(className) {
		return className + '_' + (this.props.classPostfix || '');
	}

	render() {
		const post = this.props.post || {};
		post.title = decodeText(post.title);
		if(typeof this.props.utmObj !== 'undefined') {
			post.video_config.utm = this.props.utmObj;
		}

		let target = post.open_in_new_window ? '_blank' : "_self";

		let categoryUrl = post.video_config.siteSection;
		let categoryLinkTarget = ( categoryUrl.indexOf("foxsports.com") > -1 ) ? "_self" : "_blank";

		if ( "_self" === categoryLinkTarget ) categoryUrl = categoryUrl.replace("foxsports.com","");
		
		let containerStyles = [styles.item, this.itemMediaStyles.item];
		let metaStyles = [styles.meta];
		let playBtnStyles = [playIcon.icPlayTiny, styles.zIndexOne];
		let imagesTag = parseImagesTag(post.res_imgs_tag);

		if (this.props.innerIndex === 0 && !this.isShow ) {
			if (this.addFirstItemStyles) {
				containerStyles.push(this.itemMediaStyles.firstItem);
			}

			if (this.addFirstItemMetaStyles) {
				metaStyles.push(this.itemMediaStyles.firstItemMeta);
			}
		}

		if( this.isShow ) {
			containerStyles.push(styles.showItem);
		}

		if (this.addItemMetaStyles) {
			metaStyles.push(this.itemMediaStyles.itemMeta);
		}

		if (this.state.videoHover) {
			playBtnStyles.push(playIcon.icPlayHover);
		}

		return (
			<div className={`${css(containerStyles)} ${this.getClassName('container')}-${this.props.outerIndex}`}
				 data-size={this.getContainerSize()}
				 ref={div => this.container = div}
				 onClick={this.playVideo}>
				<FsPlayer playerRef={player => this.player = player} playerConfig={post.video_config} />

				<a href={post.url}
				   title={post.title}
				   ref={a => this.link = a}
				   className={css(styles.imageLink) + ' ' + this.getClassName('image-link')}
				   onMouseEnter={this.toggleVideoHover}
				   onMouseLeave={this.toggleVideoHover} target={target}> 
					<div className={css(styles.overlay) + ' ' + this.getClassName('overlay')}>
						<img alt={post.title}
							 data-src={imagesTag.src}
							 data-srcset={imagesTag.srcSet}
							 data-sizes={imagesTag.sizes}
							 className={css(styles.image) + ' ' + this.getClassName('image') + ' lazyload'}/>
						{imagesTag.noscript &&
							<noscript>{imagesTag.noscript}</noscript>
						}
						<span className={css(styles.playIcon) + ' ' + this.getClassName('play-icon')}>
							<span className={css(playBtnStyles) + ' ' + this.getClassName('play-dtn')}></span>
							{post.video_duration &&
								<span className={css(styles.durationContainer)}>
									<span className={css(styles.duration)}>{parseSeconds(post.video_duration)}</span>
								</span>
							}
						</span>

					</div>
				</a>

				<div className={css(metaStyles) + ' ' + this.getClassName('meta')} ref={div => this.meta = div}>
					<div>
						<h2 className={ css(styles.titleHeader) + ' ' + this.getClassName('title-header')}>
							<a ref={a => this.titleLink = a}
							   href={post.url}
							   title={post.title}
							   className={ this.isShow ?
								   css(styles.titleShowLink, this.isContainerWidthOk(LARGE_FONT_SHOWN_MIN_WIDTH) && styles.titleLinkLarge) :
								   css(styles.titleLink, this.isContainerWidthOk(LARGE_FONT_SHOWN_MIN_WIDTH) && styles.titleLinkLarge) + ' ' + this.getClassName('title-link')}
								   target={target}>
								{post.title}
							</a>
						</h2>
						<div className={ this.isShow ? css(styles.props, styles.propsShow) : css(styles.props) + ' ' + this.getClassName('props')}>
							<span>
								<span className={css(styles.time) + ' ' + this.getClassName('time')}><time dateTime={post.pub_date || ''}>{post.pub_date || ''}</time></span>
								{ !this.isShow &&
									<span className={css(styles.category) + ' ' + this.getClassName('category')}>{post.category_meta.category_name || post.author}</span>
								}
							</span>

							{this.isContainerWidthOk(FB_SHARE_SHOWN_MIN_WIDTH) &&
								<FbShare url={post.url}/>
							}
						</div>
					</div>
					{this.isContainerWidthOk(SHOW_LOGO_SHOWN_MIN_WIDTH) && post.category_meta.logo_url && !this.isShow &&
						<a className={css(styles.categoryLogoContainer) + ' ' + this.getClassName('logo')} href={categoryUrl} target={categoryLinkTarget}>
							<img alt={post.title} className={css(styles.categoryLogo) + ' ' + this.getClassName('logo-img')} src={post.category_meta.logo_url} />
						</a>
					}
				</div>
			</div>
		);
	}
}

export default VideoItem;



// WEBPACK FOOTER //
// ./react-app-src/shared/components/VideoItem.js